import { signUpAnon } from "@/api/traveler";

let token = "";

export const initTokenWithEmail = async () => {
  try {
    const response = await signUpAnon({ email: generarEmailAleatorio() });
    token = response.token || "";
    return true;
  } catch (e) {
    await initTokenWithEmail();
  }
};

function generarEmailAleatorio() {
  // Función para generar una cadena aleatoria de longitud específica
  function generarCadenaAleatoria(longitud: number) {
    const caracteres = "abcdefghijklmnopqrstuvwxyz0123456789";
    let cadena = "";
    for (let i = 0; i < longitud; i++) {
      cadena += caracteres.charAt(
        Math.floor(Math.random() * caracteres.length),
      );
    }
    return cadena;
  }

  // Lista de posibles dominios
  const dominios = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "example.com",
    "protonmail.com",
    "icloud.com",
    "mail.com",
  ];

  // Genera un nombre aleatorio de longitud entre 5 y 10 caracteres
  const nombreAleatorio = generarCadenaAleatoria(
    Math.floor(Math.random() * 6) + 25,
  );

  // Genera un número aleatorio entre 100 y 999
  const numeroAleatorio = Math.floor(Math.random() * 900) + 100;

  // Selecciona un dominio aleatorio
  const dominioAleatorio =
    dominios[Math.floor(Math.random() * dominios.length)];

  // Combina todo para formar el email
  const email = `${nombreAleatorio}${numeroAleatorio}@${dominioAleatorio}`;

  return email;
}

export const getToken = () => {
  return token;
};
